import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { WaterfallTemplate } from '../index'
import { cloneDeep, keyBy } from '@dt/fe-utils/dist/lodash'
import { mallMobx } from 'mobx/mall'
import './index.scss'

const ProductTemplate = () => {
  const [productsTop, setProductsTop] = useState([])
  const [productsOther, setProductsOther] = useState([])
  const products = mallMobx.products

  useEffect(() => {
    const topList = mallMobx.brandProductTop?.productList || []
    const map = keyBy(cloneDeep(topList), item => item.productId) || {}
    let top = []
    let other = []
    products.forEach((item) => {
      if (map[item.id]) {
        top.push(item)
      } else {
        other.push(item)
      }
    })
    setProductsTop([...top])
    setProductsOther([...other])
  }, [products])
  return (
    <div className='mall-product-template'>
      <WaterfallTemplate products={productsOther} productsTop={productsTop} />
      {/* 底部分类btns */}
      {/* <CategoryBtns /> */}
    </div>
  )
}

export default observer(ProductTemplate)
